//M10-11344 Po related design changes
import { Autocomplete, Button, Spinner } from "src/components";
import excel from "src/assets/excel-dark.svg";
import { DatePickerWithRange } from "src/components/ui/date-range.component";
import { RootState } from "src/context/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { poActions } from "src/context/po-slice";
import { downloadBatchPo, generatePo, getCompanyList, getFilteredPoBatches, getStateList } from "src/services/po-api";
import { getCounterTypes } from "src/services/common-api";
import { usePoHandlers } from "./PoController";
import MultiAutocompleteAsync from "src/components/ui/MultiAutocompleteAsync";
import { useToast } from "src/hooks/useToast";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom"; //M10-12019
import { DateRange } from "react-day-picker";
import { getLast30DaysRangeISO } from "src/utils/utils";
import FormSuccess from "../../container/FormSuccess";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import { SO_TYPE_OPTIONS } from "./po.constants";

const ViewPo = () => {
    const dispatch = useDispatch();
    const { poFiltersData, poFilters } = useSelector((state: RootState) => state.po);
    const [poDataMap, setPoDataMap] = useState([]);
    const [isGeneratingPo, setIsGeneratingPo] = useState(false);
    const [isFetchingPo, setIsFetchingPo] = useState(false);
    const [dateRange, setDateRange] = useState<DateRange | undefined>(poFilters?.dateRange || getLast30DaysRangeISO());
    const [isDownloadingPo, setIsDownloadingPo] = useState(false);
    // Module filter, held locally rather than on poFilters.module: PoGenerate seeds that shared key
    // to Medvol (1) by default, and inheriting it here would silently hide every KAM batch. Unset
    // means every module, which is what this screen returned before the filter existed.
    const [selectedModule, setSelectedModule] = useState<any>(null);
    const [openGeneratePoModal, setOpenGeneratePoModal] = useState(false);
    //M10-12019
    const { state } = useLocation();
    const isNotRefresh = state?.isNotRefresh;

    useEffect(() => {
        if (isNotRefresh) return; // 🚫 don't run when true

        dispatch(poActions.setPoFilters({ key: "company", value: null }));
    }, [isNotRefresh]);

    useEffect(() => {
        if (isNotRefresh) return; // 🚫 don't run when true

        const init = async () => {
            handleResetFilters();
        };
        init();
    }, [isNotRefresh]);
    //M10-12019

    const { toast } = useToast();
    const navigate = useNavigate();

    const {
        fetchStockist,
        fetchOrders,
        fetchDivision,
        fetchProduct,
        handleResetFilters,
        companyHandler,
        stateHandler,
        stockistHandler,
        orderHandler,
        divisionHandler,
        productHandler,
        soTypeHandler   //M10-12019
    } = usePoHandlers();


    const handlePoGenerate = async () => {
        if (!poFilters?.company?.code) {
            toast({ description: "Please select company", variant: "destructive" });
            return;
        }
        if (!poFilters?.soType?.code) {
            toast({ description: "Please select SO type", variant: "destructive" });
            return;
        }
        setIsGeneratingPo(true);
        const payload = {
            company_short_code: poFilters?.company?.shortcode,
            company_code: poFilters?.company?.code,
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            date_to: dateRange?.to,
            date_from: dateRange?.from,
            po_generatetype: poFilters?.soType?.code,
            so_day_count: dateRange?.from && dateRange?.to
                ? moment.utc(dateRange.to).endOf("day").diff(moment.utc(dateRange.from).startOf("day"), "days") + 1
                : 0
        }
        try {
            const res = await generatePo(payload);
            toast({ description: "PO generation requested successfully", variant: "default" });
            if (res?.data?.success == true) {
                handleResetFilters();
            }
        } catch (error: any) {
            toast({ description: error?.response?.data?.message || "Something went wrong", variant: "destructive" });
        } finally {
            setIsGeneratingPo(false);
        }
    }

    const fetchFilteredPo = async () => {
        setIsFetchingPo(true);
        const payload = {
            company_code: poFilters?.company?.code,
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            comp_stockist_codes: poFilters?.stockist?.map((item: any) => item?.company_stockist_code)?.join(","),
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            date_to: dateRange?.to,
            date_from: dateRange?.from,
            po_generatetype: poFilters?.soType?.code,
            module_code: selectedModule?.module_code
        }

        try {
            const response = await getFilteredPoBatches(payload);
            console.log(response);
            setPoDataMap(response?.data?.data);
            dispatch(poActions.setPoDetails(response?.data?.data));
            toast({ description: "PO fetched successfully", variant: "default" });
        } catch (error) {
            console.error("Error fetching PO data:", error);
            toast({ description: "Error fetching PO data", variant: "destructive" });
        } finally {
            setIsFetchingPo(false);
        }
    };


    // const dateRangeHandler = (details: DateRange | undefined) => {
    //     if (details?.from) {
    //         const fromDate = new Date(details.from);
    //         const toDate = details.to ? new Date(details.to) : undefined;

    //         const isSameDate = toDate && fromDate.getTime() === toDate.getTime();

    //         const payload: DateRange = {
    //             from: fromDate.toISOString() as any,
    //             ...(toDate && !isSameDate && { to: toDate.toISOString() as any }),
    //         };
    //         dispatch(poActions.setPoFilters({ key: "dateRange", value: payload }));
    //         setDateRange(payload);
    //     }
    // };

    const dateRangeHandler = (details: DateRange | undefined) => {
        if (details?.from) {
            const fromDate = new Date(details.from);
            const toDate = details.to ? new Date(details.to) : undefined;

            // Set fromDate to start of the day
            fromDate.setHours(0, 0, 0, 0);

            // Set toDate to end of the day if it's provided
            if (toDate) {
                toDate.setHours(23, 59, 59, 999);
            }

            const isSameDate =
                toDate &&
                fromDate.toDateString() === toDate.toDateString();

            const payload: DateRange = {
                from: fromDate.toISOString() as any,
                ...(toDate && !isSameDate && { to: toDate.toISOString() as any }),
            };

            dispatch(poActions.setPoFilters({ key: "dateRange", value: payload }));
            setDateRange(payload);
        }
    };

    const handleDownloadPo = async (item: any) => {
        try {
            setIsDownloadingPo(true);
            const response = await downloadBatchPo({
                company_code: item?.company_code,
                po_batch_id: item?.po_batch_id,
                batch_id: item?.batch_id,
                po_generatetype: item?.po_generatetype,
            })
            const presignedUrl = response?.data?.presignedUrl;
            if (presignedUrl) {
                const link = document.createElement("a");
                link.href = presignedUrl;

                // Optional: Extract filename from URL
                const filename = presignedUrl.split("/").pop()?.split("?")[0] || "file.csv";
                link.setAttribute("download", filename);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Clean up
            } else {
                toast({ description: "Presigned URL not found in response.", variant: "destructive" });
            }
        } catch (error: any) {
            toast({ description: error?.response?.data?.message || "Something went wrong", variant: "destructive" });
            console.error("Error downloading file", error);
        } finally {
            setIsDownloadingPo(false);
        }
    }


    useEffect(() => {
        fetchFilteredPo();
    }, [poFilters, selectedModule]);

    useEffect(() => {
        if (!poFiltersData?.company?.length) {
            getCompanyList()
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "company", value: res?.data })))
                .catch((err) => console.log(err));

        }
        if (!poFiltersData?.state?.length) {
            getStateList()
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "state", value: res?.data?.data })))
                .catch((err) => console.log(err));
        }
        if (!poFiltersData?.module?.length) {
            // PUC=true unlocks the full module list (Medvol/POB/PUC/KAM); default returns only 1,2.
            // Same source as PoGenerate — no default selection here, so all modules are listed.
            getCounterTypes("?PUC=true")
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "module", value: res?.data?.data || [] })))
                .catch((err) => console.log(err));
        }
    }, [dispatch]);


    return (
        <>
            <div>
                <div className="flex justify-between items-center gap-2">
                    <div className="flex gap-2 w-[85%] [@media(min-width:1580px)]:w-[85%]">
                        <Autocomplete
                            onSelectionChange={companyHandler}
                            placeholder="Company"
                            inputClassName="w-fit"
                            suggestionList={poFiltersData?.company || []}
                            displayKey="name"
                            defaultValue={poFilters?.company}
                            uniqueKey="code" />
                        <Autocomplete
                            onSelectionChange={soTypeHandler}   //M10-12019
                            placeholder="SO Type"
                            inputClassName="w-fit"
                            suggestionList={SO_TYPE_OPTIONS}
                            displayKey="name"
                            defaultValue={poFilters?.soType}
                            uniqueKey="code" />
                        <Autocomplete
                            onSelectionChange={(value: any) => setSelectedModule(value)}
                            placeholder="Module"
                            inputClassName="w-fit"
                            suggestionList={poFiltersData?.module || []}
                            displayKey="module_desc"
                            defaultValue={selectedModule}
                            uniqueKey="module_code" />

                        <div className="border border-[#E5E5E5] rounded-lg max-h-[35px] flex items-center">
                            <div className="p-2 text-gray-400">
                                Date:
                            </div>
                            <DatePickerWithRange className="" date={poFilters?.dateRange || dateRange} dateRangeHandler={dateRangeHandler} />
                        </div>
                        <MultiAutocompleteAsync
                            placeholder="States"
                            inputClassName="w-fit"
                            suggestionList={poFiltersData?.state || []}
                            controlledValue={poFilters?.state}
                            displayKey="state_name"
                            uniqueKey="state_code"
                            defaultValue={poFilters?.state}
                            onSelectionChange={stateHandler}
                            showSelectAll={true}
                        />
                    </div>
                    <div className="flex gap-2">
                        <Button disabled={isGeneratingPo} isLoading={isGeneratingPo} loaderSize="small" className="font-normal text-white bg-[#8051FF]"
                            onClick={fetchFilteredPo} module={fineGrainedPermissionsKeys.PURCHASEORDER.VIEWPODETAILS.module} action={fineGrainedPermissionsKeys.PURCHASEORDER.VIEWPODETAILS.action}>
                            View PO
                        </Button>
                        <Button disabled={isGeneratingPo} onClick={() => { setSelectedModule(null); handleResetFilters(); }} className="font-normal text-black bg-[#F1F1F1]">
                            Reset
                        </Button>
                    </div>
                </div>
                <div className="mt-1 w-[70%] flex items-center gap-2 [@media(min-width:1580px)]:w-[70%]">

                    <MultiAutocompleteAsync
                        placeholder="Stockists"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.stockist || []}
                        displayKey="stockist_name"
                        uniqueKey="company_stockist_code"
                        controlledValue={poFilters?.stockist}
                        defaultValue={poFilters?.stockist}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchStockist : undefined}
                        onSelectionChange={stockistHandler}
                        showSelectAll={true}
                        additionalDisplayKey={true}
                        additionalDisplayKeySearch="company_stockist_code"
                        showSecondaryDisplayKey={true}
                        secondaryDisplayKey="company_stockist_code"
                    />
                    <MultiAutocompleteAsync
                        placeholder="Orders"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.orders || []}
                        displayKey="order_code"
                        uniqueKey="order_id_int"
                        defaultValue={poFilters?.orders}
                        controlledValue={poFilters?.orders}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchOrders : undefined}
                        onSelectionChange={orderHandler}
                        showSelectAll={true}
                    />
                    <MultiAutocompleteAsync
                        placeholder="Divisions"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.division || []}
                        displayKey="division_name"
                        uniqueKey="company_divisioncode"
                        defaultValue={poFilters?.division}
                        controlledValue={poFilters?.division}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchDivision : undefined}
                        onSelectionChange={divisionHandler}
                        showSelectAll={true}
                    />

                    <MultiAutocompleteAsync
                        placeholder="Products"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.products || []}
                        displayKey="item_code"
                        uniqueKey="item_code"
                        defaultValue={poFilters?.products}
                        controlledValue={poFilters?.products}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchProduct : undefined}
                        onSelectionChange={productHandler}
                        showSelectAll={true}
                        // M10-15255
                        showSecondaryDisplayKey={true}
                        secondaryDisplayKey="item_description"
                        additionalDisplayKey={true}
                        additionalDisplayKeySearch="item_description"
                        // M10-15255
                    />
                </div>

                <div className="mt-4 mb-6 border-2 border-gray-200 p-6 rounded-xl shadow-sm">
                    <h4 className="text-[#49484C] font-bold text-[1.2rem]">Result Found</h4>
                    {isFetchingPo ? <div className="flex justify-center items-center h-[20rem]"><Spinner /></div> :
                        <table className="min-w-full mt-5 border-2 border-gray-200">
                            <thead className="w-full bg-gray-100">
                                <tr>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">Sr No.</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">Company Name</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">Module</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">SO Type</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">SO Date</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">SO Day Count</th>
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">Status</th> 
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l">PO Count</th> 
                                    <th className="px-1 py-2 text-sm text-left text-gray-600 border-l whitespace-nowrap">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {poDataMap?.length ? (poDataMap?.map((item: any, index: number) => {
                                    const poDate = new Date(item?.created_date);
                                    return (
                                        <tr key={index} className="text-sm text-[#303030]">
                                            <td className="px-1 py-2 border-t border-l">{index + 1}</td>
                                            <td className="px-1 py-2 border-t border-l">{poFilters?.company?.name}</td>
                                            <td className="px-1 py-2 border-t border-l">{poFiltersData?.module?.find((module: any) => module?.module_code === item?.module_code)?.module_desc ?? (item?.module_code ?? '-')}</td>
                                            <td className="px-1 py-2 border-t border-l">{item?.po_generatetype}</td>
                                            {/* M10-12204 */}
                                            <td className="px-1 py-2 border-t border-l">{moment(poDate).format("DD-MM-YYYY hh:mm A")}</td>
                                            <td className="px-1 py-2 border-t border-l">{item?.so_day_count}</td>
                                            <td className="px-1 py-2 border-t border-l">{item?.po_batch_status ? item?.po_batch_status : '-'}</td>
                                            <td className="px-1 py-2 border-t border-l">{item?.po_count ? item?.po_count : '-'}</td>
                                            <td className="px-1 py-2 border-t border-l whitespace-nowrap w-[8rem]">
                                                <div className="flex items-center gap-2">
                                                    <Button onClick={() => handleDownloadPo(item)} className="bg-[#F1F1F1] border border-[#d0d0d0] text-xs font-medium px-1 py-1 flex items-center gap-2">
                                                        {isDownloadingPo ? <Spinner size="small" /> : <img src={excel} alt="excel" className="w-4 h-4" />}
                                                    </Button>
                                                    <Button onClick={() => navigate(`/transactions/purchase-order/${item?.po_batch_id}`)} className="bg-[#F1F1F1] border border-[#d0d0d0] text-xs font-medium px-3 py-1 flex items-center gap-2">
                                                        View PO
                                                    </Button>
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                }))
                                    : <tr><td colSpan={6} className="text-center text-[#49484C] h-[50vh]">No Data Found</td></tr>}
                            </tbody>
                        </table>}

                </div>
            </div>
            <FormSuccess
                onCloseModal={() => {
                    setOpenGeneratePoModal(false)
                }}
                showForm={openGeneratePoModal}
                onContinue={() => {
                    setOpenGeneratePoModal(false)
                    handlePoGenerate();
                }}
                variant=""
                popupMessage={{
                    description: `Are you sure you want to generate PO for ${poFilters?.company?.name}?`,
                    title: "Generate PO!",
                }}
                enableBackButton={true}
            />
        </>
    );
};

export default ViewPo;
//M10-11344 Po related design changes